import React, { memo, useEffect, useState } from 'react';
import { Text, View, StyleSheet, Image } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../constants/styles';
import { I18n, Utils, Container, CTAButton, Navigation, Select } from '../../components';

import { REQUESTING, SUCCESS } from '../../../actions/statusTypes';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resetState } from './slice';

import {
  ROLE_TYPE_UDM,
  ROLE_TYPE_MED_STAFF,
  ROLE_TYPE_PATIENT,
  ROLE_TYPE_COMMANDER,
} from '../../../constants/roleTypes';
const ROLE_TYPES = [ROLE_TYPE_UDM, ROLE_TYPE_MED_STAFF, ROLE_TYPE_PATIENT, ROLE_TYPE_COMMANDER];
const ROLE_TYPES_OPTIONS = ROLE_TYPES.reduce(Utils.optionReducer, []);

const RequestForm = memo((props) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [roleType, setRoleType] = useState(ROLE_TYPE_UDM);

  useEffect(() => {
    props.actions.resetState({ statusOnly: true });
  }, []);
  useEffect(() => {
    if (props.status === SUCCESS) {
      setSubmitSuccess(true);
    }
  }, [props.status]);

  const submitSuccessView = (
    <View
      style={[
        !props.isVerticalLayout ? { minHeight: '100%' } : { flex: 1 },
        styles.successContainer,
      ]}
    >
      <View>
        <Image
          style={styles.closeIcon}
          source={require('../../../../resources/icon-success-thank-you.png')}
        />
        <Text style={styles.requestSuccessLabel}>{I18n.t('auth.requestSuccessTitle')}</Text>
        <Text stlye={THEME.textRegular}>{I18n.t('auth.requestSuccessBody')}</Text>
      </View>
    </View>
  );

  const startRequest = () => {
    Navigation.showModal({
      screen: 'AccessRequestFormScreen',
      title: 'Request Access to Outpatient App',
      passProps: { roleType, base: props.base },
    });
  };
  return (
    <Container
      errorMessage={props.errorMessage}
      renderActivityOverlay={props.baseInfoStatus === REQUESTING}
      scrollView={false}
      style={styles.container}
    >
      <View style={styles.paneWrapper}>
        {!!submitSuccess ? (
          submitSuccessView
        ) : (
          <>
            <View style={styles.inputsContainer}>
              <View>
                <Text style={styles.contentTitle}>{I18n.ac('auth.requestAccess')}</Text>
                <Text style={[THEME.textRegular, { marginBottom: 20 }]}>
                  {I18n.t('auth.requestAccessBody')}
                </Text>
              </View>
              <Select
                closeOnSelect={true}
                options={ROLE_TYPES_OPTIONS}
                label={I18n.ac('airforce.roleType')}
                value={roleType}
                onSelect={setRoleType}
                webMode={true}
                editable={true}
              />
            </View>
            <CTAButton onPress={startRequest} label={I18n.t('auth.requestAccess')} />
          </>
        )}
      </View>
    </Container>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingBottom: 100,
    paddingTop: 30,
  },
  paneWrapper: {
    flex: 1,
    maxWidth: 400,
    width: '100%',
    maxHeight: '100%',
    scrollY: 'auto',
    marginVertical: 20,
    marginHorizontal: 'auto',
  },
  inputsContainer: {
    zIndex: 1000,
    paddingBottom: 30,
  },
  successContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 100,
    paddingBottom: 100,
  },
  requestSuccessLabel: {
    ...FONT.FONT_SIZE_HUGE,
    ...FONT.FONT_SEMIBOLD,
    color: COLOR.text,
    fontSize: FONT_SIZE.enormous,
    marginTop: 30,
    marginBottom: 30,
    textTransform: 'uppercase',
  },
  contentTitle: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: FONT_SIZE.huge,
    marginBottom: 30,
    letterSpacing: 3,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.baseUnauthed.inviteRequestStatus,
    baseInfoStatus: state.screens.baseUnauthed.baseInfoStatus,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ resetState }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(RequestForm);
